/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { arrowRight, play } from 'components/landing/ui/icons';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Button, colors, Container, Link, Stripes } from '../../../ui';

const MenuItem = styled('span')(({ active }) => ({
  cursor: 'pointer',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '30px',
  transition: 'all .2s',
  textTransform: 'uppercase',
  pointerEvents: active ? 'none' : 'all',
  color: active ? colors.blue : colors.black,
  ':hover': { color: colors.blue },
}));

const HeaderMobileMenu = React.memo(
  ({ activeSection, scrollTo, onClose, openTariffs, openVideo, inDevelopment }) => {
    const handleClick = e => {
      const { nodeName } = e.target;

      if (['BUTTON', 'SPAN', 'A'].includes(nodeName)) onClose();
    };

    return (
      <Container
        css={{
          height: 'calc(100vh - 83px)',
          position: 'fixed',
          top: 83,
          background: '#fff',
          zIndex: 4,
          flexDirection: 'column',
        }}
        onClick={handleClick}
      >
        <div
          css={{
            position: 'relative',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: '6%',
            paddingBottom: '5%',
            maxHeight: '100%',
            flexGrow: 1,
          }}
        >
          {/* <RouterLink to="/lk" css={{ width: '100%', maxHeight: 55, flexGrow: 3 }} target="_blank">
          </RouterLink> */}
          <Button
            css={{ width: '100%', minHeight: 'unset', height: '100%' }}
            onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
          >
            Личный Кабинет
          </Button>
          <div
            css={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 1,
              flexGrow: 3,
              paddingTop: '2%',
              paddingBottom: '2%',
            }}
          >
            <nav
              css={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                flexShrink: 1,
                flexGrow: 1,
                '>span:not(:last-of-type)': { marginBottom: '1%' },
              }}
            >
              <MenuItem onClick={() => scrollTo(1)} active={activeSection === 1}>
                Обзор
              </MenuItem>
              <MenuItem onClick={() => scrollTo(2)} active={activeSection === 2}>
                Отзывы
              </MenuItem>
              <MenuItem onClick={() => scrollTo(3)} active={activeSection === 3}>
                Кейсы
              </MenuItem>
              <MenuItem onClick={openTariffs}>Тарифы</MenuItem>
            </nav>
          </div>

          <div
            css={{
              width: '100%',
              flexGrow: 3,
              flexShrink: 1,
              position: 'relative',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
              'a, >button': { width: '100%', maxHeight: 55, flexGrow: 1 },
              button: { width: '100%', height: '100%', minHeight: 'unset' },
              marginBottom: '3%',
              '>a, >button': { marginBottom: 5 },
            }}
          >
            <Button type="black" icon={play} onClick={() => openVideo('about')}>
              Видео обзор
            </Button>

            {/* <RouterLink to="/lk" target="_blank">
            </RouterLink> */}
            <Button
              type="blue"
              icon={arrowRight}
              onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
            >
              Попробовать бесплатно
            </Button>

            <RouterLink target="_blank">
              <Button>Обучающий вебинар</Button>
            </RouterLink>

            <RouterLink target="_blank" onClick={inDevelopment}>
              <Button>Бот учитель</Button>
            </RouterLink>

            <RouterLink target="_blank" onClick={inDevelopment}>
              <Button>Телеграм Канал</Button>
            </RouterLink>
          </div>

          <div
            css={{
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <a
              href="https://vk.com/vsemsmm1"
              target="_blank"
              rel="noopener noreferrer"
              css={{
                fontFamily: 'Open Sans',
                fontSize: 16,
                lineHeight: '22px',
                fontWeight: 400,
                color: colors.grayLight,
                whiteSpace: 'pre-line',
                wordBreak: 'break-word',
                transition: '.2s',
                ':hover': { color: colors.blue },
              }}
            >
              Техническая поддержка
            </a>
          </div>

          <Stripes />
        </div>
      </Container>
    );
  }
);

export default HeaderMobileMenu;
